
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react'
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { OneMealService } from '../../services/OneMealService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import EditMealMapDialog from './EditMealMapDialog';
import { useRefresh } from 'react-admin';
import { CustomSnackbarTypes } from './CustomSnackBar';



const oneMealService = new OneMealService();

function MealMapTable(props : any) {
    const[dishData, setDishData] = useState<any>([]);
    const[openEditDish, setOpenEditDish] = useState<boolean>(false);
    const[dishToEdit, setDishToEdit] = useState<any>();
    const refersh = useRefresh();

    function editDish(dish: any){
        setOpenEditDish(true);
        setDishToEdit(dish);
    }


    const removeDishFormMealMap = (dishId : number) =>{
        EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
            message: "Are you sure you want to remove this Dish?",
            onClose: async (confirmed: boolean) => {
              if (confirmed) {
                let payload = {
                    addedDishes: dishData.filter((dish : any)=> dish?.id !== dishId)
                }
                await oneMealService.changeMealMap(props?.omsId,payload);
                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                    message: "Removed Successfully",
                    type: CustomSnackbarTypes.SUCCESS,
                });
                refersh();
              }
            },
            title: "Confirmation"
        });
    }

    
    useEffect(()=>{
        if(props.mealMap && props.mealMap.length > 0){
            setDishData(props?.mealMap.map ((dish: any) => {
                if(!dish.dishId){
                    return {
                        // custom dish
                        id : dish?.id,
                        dishName: dish?.dishName,
                        dishCount: dish?.dishCount,
                        dishType : dish?.dishType
                    }
                }
                return {
                    id : dish?.id,
                    dishId: dish?.dishId,
                    dishName: dish?.dishName,
                    dishCount: dish?.dishCount,
                    dishType : dish?.dishType
                }

            } ))
        }
    },[props?.mealMap])
  const totalRows = props.totalRows != null
    ? Math.max(props.totalRows, props?.mealMap?.length ?? 0)
    : props?.mealMap?.length ?? 0;

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: "8px", width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "rgba(232, 235, 237, 0.3)" }}>
              <TableCell sx={{ fontWeight: 600, width: "48px" }}>#</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Dish Name</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "100px", textAlign: "center" }}>Quantity</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "80px", textAlign: "center" }}>Edit</TableCell>
              <TableCell sx={{ fontWeight: 600, width: "80px", textAlign: "center" }}>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {totalRows > 0 ? Array.from({ length: totalRows }).map((_, i) => {
              const dish = props?.mealMap?.[i];
              return (
                <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell sx={{ color: "#6C7C93", fontSize: "13px" }}>{i + 1}</TableCell>
                  <TableCell sx={{ fontSize: "14px", fontWeight: 500 }}>{dish?.dishName ?? "-"}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{dish?.dishCount ?? "-"}</TableCell>
                  <TableCell sx={{ textAlign: "center", padding: "4px" }}>
                    {dish ? (
                      <IconButton color="primary" size="small" onClick={() => editDish(dish)}>
                        <EditRoundedIcon fontSize="small" color="primary" />
                      </IconButton>
                    ) : "-"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", padding: "4px" }}>
                    {dish ? (
                      <IconButton color="error" size="small" onClick={() => removeDishFormMealMap(dish?.id)}>
                        <DeleteRoundedIcon fontSize="small" color="error" />
                      </IconButton>
                    ) : "-"}
                  </TableCell>
                </TableRow>
              );
            }) : null}
          </TableBody>
        </Table>
      </TableContainer>
      <EditMealMapDialog data={props?.mealMap} dish={dishToEdit} open={openEditDish} callback={() => { setOpenEditDish(false) }} />
    </>
  )
}

export default MealMapTable
